'use strict';

// var modulo = require('./modulo');
var $floor = Math.floor;

// http://ecma-international.org/ecma-262/5.1/#sec-5.2

module.exports = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/5/floor.js
 ** module id = 2932
 ** module chunks = 0
 **/